export const DRAWER_OVERWRITE = {
  classNames: {
    Content: {
      base: '',
      noRounded: 'rounded-none',
    },
  },
};
